import { useEffect, useState } from "react";
import { Link, useNavigate, Outlet, useLocation } from "react-router-dom";
import { LogOut, FolderKanban, Receipt, Home as HomeIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LOGO_URL } from "@/lib/constants";
import { clientApi } from "@/lib/api";

export default function ClientLayout() {
  const [me, setMe] = useState(null);
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    const t = localStorage.getItem("pn_client_token");
    if (!t) { nav("/portail/login"); return; }
    clientApi.get("/client/me").then(({ data }) => setMe(data)).catch(() => {
      localStorage.removeItem("pn_client_token");
      nav("/portail/login");
    });
  }, [nav]);

  const logout = () => {
    localStorage.removeItem("pn_client_token");
    localStorage.removeItem("pn_client_name");
    localStorage.removeItem("pn_client_email");
    nav("/portail/login");
  };

  if (!me) return null;

  const tabs = [
    { to: "/portail", icon: HomeIcon, label: "Tableau de bord", exact: true },
    { to: "/portail/projets", icon: FolderKanban, label: "Mes projets" },
    { to: "/portail/factures", icon: Receipt, label: "Mes factures" },
  ];

  return (
    <div className="min-h-screen bg-[#F5F7FA]">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-30">
        <div className="mx-auto max-w-7xl px-6 md:px-10 h-16 flex items-center justify-between">
          <Link to="/portail" className="flex items-center gap-2">
            <img src={LOGO_URL} alt="" className="h-9 w-9 object-contain" />
            <div className="hidden sm:block leading-tight">
              <div className="font-heading font-bold text-[#0B1F3A] text-sm">Portail client</div>
              <div className="text-[10px] tracking-wider uppercase text-[#00B8D9] font-semibold">Passerelle Numérique</div>
            </div>
          </Link>
          <div className="flex items-center gap-3">
            <div className="text-right hidden sm:block">
              <div className="text-sm font-semibold text-[#0B1F3A]">{me.name}</div>
              <div className="text-xs text-[#4B5563]">{me.company}</div>
            </div>
            <Button onClick={logout} variant="outline" size="sm" data-testid="client-logout"><LogOut className="h-4 w-4 mr-1" /> Quitter</Button>
          </div>
        </div>
        <div className="mx-auto max-w-7xl px-6 md:px-10 flex gap-1 overflow-x-auto">
          {tabs.map((t) => {
            const active = t.exact ? loc.pathname === t.to : loc.pathname.startsWith(t.to);
            return (
              <Link
                key={t.to}
                to={t.to}
                data-testid={`portal-tab-${t.label.toLowerCase().replace(/\s/g, "-")}`}
                className={`flex items-center gap-2 px-4 py-3 border-b-2 text-sm font-semibold whitespace-nowrap transition-colors ${
                  active ? "border-[#00B8D9] text-[#00B8D9]" : "border-transparent text-[#4B5563] hover:text-[#0B1F3A]"
                }`}
              >
                <t.icon className="h-4 w-4" /> {t.label}
              </Link>
            );
          })}
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-6 md:px-10 py-8">
        <Outlet context={{ me }} />
      </main>
    </div>
  );
}
